import { CardHeader as _CardHeader, CardHeaderProps as _CardHeaderProps } from "reactstrap";

    export const CardHeader = _CardHeader;
    export type CardHeaderProps = _CardHeaderProps;
    